/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import { useHookstateEffect } from "@hookstate/core";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import { ProductDetails } from "../components/ProductDetails/ProductDetails";
import { SiteLayout } from "../components/SiteLayout";
import { AppConstants } from "../data/AppConstants";
import { useCheckoutFormState } from "../hooks/useCheckoutFormState";
import { useProductDetailsState } from "../hooks/useProductDetailsState";

//------------------------------------------------------------------------------------ 
type ProductPageProps = {

}
const ProductPage: React.FC<ProductPageProps> = props => {
    const { productid, warehouseid, locationid, fromdate, todate } = useParams();
    const productDetailsState = useProductDetailsState();
    const product = productDetailsState.get().product;
    let productDetailsProductId: string | undefined;
    if (product !== undefined) {
        productDetailsProductId = product.Id;
    }
    const checkoutFormState = useCheckoutFormState();
    const navigate = useNavigate();

    useHookstateEffect(() => {
        if (product !== undefined) {
            const today = dayjs().startOf('day');
            let newFromDate = fromdate;
            let newToDate = todate;
            let needsToNavigate = false;
            if (dayjs(fromdate).isBefore(today)) {
                newFromDate = today.format('YYYY-MM-DD');
                newToDate = dayjs(fromdate).add(6, 'day').format('YYYY-MM-DD');
                needsToNavigate = true;
            }
            if (dayjs(todate).isBefore(fromdate)) {
                newToDate = dayjs(fromdate).add(6, 'day').format('YYYY-MM-DD');
                needsToNavigate = true;
            }
            if (needsToNavigate) {
                navigate(`/product/${product.Id}/warehouseid/${warehouseid}/locationid/${locationid}/fromdate/${newFromDate}/todate/${newToDate}`)
                //window.history.pushState(null, '', `/storefront/product/${product.Id}/warehouseid/${warehouseid}/locationid/${locationid}/fromdate/${newFromDate}/todate/${newToDate}`);
            }
        }
    }, [fromdate, todate]);

    useHookstateEffect(() => {
        (async () => {
            //console.log(`productid: ${productid}, productDetailsProductId: ${productDetailsProductId}`)
            if (warehouseid && productid && !productDetailsState.get().isLoadingProductDetails && ((!productDetailsProductId) || (productDetailsProductId && (productid !== productDetailsProductId)))) {
                // Always set the warehouse and location from URL parameters first
                checkoutFormState.setWarehouseId(warehouseid);
                
                if (locationid) {
                    checkoutFormState.setLocationId(locationid);
                }
                
                // Set dates if provided in URL
                if (fromdate) {
                    checkoutFormState.setFromDate(fromdate);
                }
                if (todate) {
                    checkoutFormState.setToDate(todate);
                }
                
                // Since the setters are synchronous, we can call the product loading immediately
                await productDetailsState.setProductIdAsync(productid, warehouseid, locationid, fromdate, todate);
            }
        })();
    }, [productid, productDetailsProductId, warehouseid, locationid, fromdate, todate]);

    return (<>
        <SiteLayout
            title="Product"
            mainChildren={<>
                <div css={css`
                    display:flex;
                    justify-content:center;
                    overflow:hidden;
                    `}>
                    <div css={css`
                        flex:1 1 0;
                        max-width:${AppConstants.siteWidthCss};
                        display:flex;
                        justify-content:center;
                        @media screen {
                            overflow: auto;
                        }
                    `}>
                        <ProductDetails printMode={false} />
                    </div>
                </div>
            </>}
        />
    </>);
}

export default ProductPage